/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 106);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(0)
  , ctx       = __webpack_require__(37)
  , hide      = __webpack_require__(8)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(40)
  , defined = __webpack_require__(16);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(11)
  , IE8_DOM_DEFINE = __webpack_require__(39)
  , toPrimitive    = __webpack_require__(27)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(2) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(6)
  , createDesc = __webpack_require__(14);
module.exports = __webpack_require__(2) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(46)
  , enumBugKeys = __webpack_require__(17);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(24)('wks')
  , uid        = __webpack_require__(15)
  , Symbol     = __webpack_require__(3).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(11)
  , dPs         = __webpack_require__(42)
  , enumBugKeys = __webpack_require__(17)
  , IE_PROTO    = __webpack_require__(23)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(38)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(76).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f
  , has = __webpack_require__(5)
  , TAG = __webpack_require__(10)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(24)('keys')
  , uid    = __webpack_require__(15);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(16);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(3)
  , core           = __webpack_require__(0)
  , LIBRARY        = __webpack_require__(19)
  , wksExt         = __webpack_require__(29)
  , defineProperty = __webpack_require__(6).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractScrollBox = exports.ScrollEasing = exports.ScrollCause = exports.FastTrackMode = undefined;

var _values = __webpack_require__(57);

var _values2 = _interopRequireDefault(_values);

var _defineProperties = __webpack_require__(54);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _objectWithoutProperties2 = __webpack_require__(62);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(61);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(31);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(32);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(48);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(105);

var _propTypes = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FastTrackMode = exports.FastTrackMode = {
  PAGING: 'paging',
  GOTO: 'goto'
};

var ScrollCause = exports.ScrollCause = {
  HANDLE_DRAG: 0,
  MOUSE_WHEEL: 1,
  FAST_TRACK: 2,
  KEYBOARD: 3,
  TOUCH: 4
};

var ScrollEasing = exports.ScrollEasing = {
  easeQuadOut: function easeQuadOut(percent, elapsed, min, max, duration) {
    percent -= 1;
    return min + max * Math.sqrt(1 - Math.pow(percent, 2));
  }
};

var AbstractScrollBox = exports.AbstractScrollBox = function (_React$Component) {
  (0, _inherits3.default)(AbstractScrollBox, _React$Component);

  function AbstractScrollBox(props) {
    (0, _classCallCheck3.default)(this, AbstractScrollBox);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractScrollBox.__proto__ || (0, _getPrototypeOf2.default)(AbstractScrollBox)).call(this, props));

    var _scrollX = 0,
        _scrollY = 0,
        _prevX = 0,
        _prevY = 0,
        _targetX = 0,
        _targetY = 0,
        _durationX = 0,
        _durationY = 0,
        _easingX = void 0,
        _easingY = void 0,
        _timestampX = 0,
        _timestampY = 0,
        _dispatchPrevented = false,
        _scrollMaxX = 0,
        _scrollMaxY = 0,
        _trackMaxX = 0,
        _trackMaxY = 0,
        _requiresScrollBarX = false,
        _requiresScrollBarY = false,
        _requestId = void 0,
        _scrollingX = false,
        _scrollingY = false,
        _causeX = null,
        _causeY = null,
        _tickX = 0,
        _tickY = 0,


    // Refs
    _root = void 0,
        _viewport = void 0,
        _handleX = void 0,
        _handleY = void 0,
        _trackX = void 0,
        _trackY = void 0;

    var setHandleX = function setHandleX(ref) {
      return _handleX = ref;
    };
    var setHandleY = function setHandleY(ref) {
      return _handleY = ref;
    };

    var setTrackX = function setTrackX(ref) {
      return _trackX = ref;
    };
    var setTrackY = function setTrackY(ref) {
      return _trackY = ref;
    };

    _this.componentDidMount = function () {
      _root = (0, _reactDom.findDOMNode)(_this);
      _viewport = _root.firstChild;

      var requestPropagateChanges = function requestPropagateChanges() {
        if (window.cancelAnimationFrame) {
          _requestId = requestAnimationFrame(requestPropagateChanges);
        } else {
          _requestId = setTimeout(requestPropagateChanges, 1000 / 30);
        }
        propagateChanges();
      };

      requestPropagateChanges();
      addEventListener('mousemove', handleTrackHover);

      // Fix https://github.com/facebook/react/issues/8968
      _root.addEventListener('touchstart', handleTouchStart);
    };

    _this.componentWillUnmount = function () {
      _root = null;

      if (window.cancelAnimationFrame) {
        cancelAnimationFrame(_requestId);
      } else {
        clearTimeout(_requestId);
      }
      removeEventListener('mousemove', handleTrackHover);
    };

    _this.componentDidUpdate = function () {
      _viewport = _root.firstChild;
      propagateChanges();
    };

    _this.render = function () {
      var _this$props = _this.props,
          className = _this$props.className,
          style = _this$props.style,
          disabled = _this$props.disabled,
          outsetScrollBarX = _this$props.outsetScrollBarX,
          outsetScrollBarY = _this$props.outsetScrollBarY,
          nativeScrollBars = _this$props.nativeScrollBars,
          disableScrollX = _this$props.disableScrollX,
          disableScrollY = _this$props.disableScrollY,
          hideScrollBarX = _this$props.hideScrollBarX,
          hideScrollBarY = _this$props.hideScrollBarY,
          children = _this$props.children,
          trackChildrenX = _this$props.trackChildrenX,
          trackChildrenY = _this$props.trackChildrenY,
          handleChildrenX = _this$props.handleChildrenX,
          handleChildrenY = _this$props.handleChildrenY;


      var classNames = ['scroll-box'];
      if (className) {
        classNames.push(className);
      }
      if (disabled) {
        classNames.push('scroll-box--disabled');
      }
      if (outsetScrollBarX) {
        classNames.push('scroll-box--outset-x');
      }
      if (outsetScrollBarY) {
        classNames.push('scroll-box--outset-y');
      }
      if (!disableScrollX && !hideScrollBarX) {
        classNames.push('scroll-box--enable-x');
      }
      if (!disableScrollY && !hideScrollBarY) {
        classNames.push('scroll-box--enable-y');
      }
      if (nativeScrollBars) {
        classNames.push('scroll-box--native-scroll-bars');
      }

      return _react2.default.createElement(
        'div',
        { style: style,
          className: classNames.join(' '),
          onWheel: handleWheel,
          onKeyDown: handleKeyDown,
          tabIndex: '-1' },
        children,
        _react2.default.createElement(
          'div',
          { className: 'scroll-box__track scroll-box__track--x',
            onMouseDown: handleFastTrackX,
            ref: setTrackX },
          _react2.default.createElement(
            'div',
            { className: 'scroll-box__handle scroll-box__handle--x',
              onMouseDown: handleDragStartX,
              ref: setHandleX },
            handleChildrenX
          ),
          trackChildrenX
        ),
        _react2.default.createElement(
          'div',
          { className: 'scroll-box__track scroll-box__track--y',
            onMouseDown: handleFastTrackY,
            ref: setTrackY },
          _react2.default.createElement(
            'div',
            { className: 'scroll-box__handle scroll-box__handle--y',
              onMouseDown: handleDragStartY,
              ref: setHandleY },
            handleChildrenY
          ),
          trackChildrenY
        )
      );
    };

    _this.scrollTo = function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          x = _ref.x,
          y = _ref.y,
          easing = _ref.easing,
          _ref$easingX = _ref.easingX,
          easingX = _ref$easingX === undefined ? easing || _this.props.easingX : _ref$easingX,
          _ref$easingY = _ref.easingY,
          easingY = _ref$easingY === undefined ? easing || _this.props.easingY : _ref$easingY,
          _ref$duration = _ref.duration,
          duration = _ref$duration === undefined ? 0 : _ref$duration,
          _ref$durationX = _ref.durationX,
          durationX = _ref$durationX === undefined ? duration : _ref$durationX,
          _ref$durationY = _ref.durationY,
          durationY = _ref$durationY === undefined ? duration : _ref$durationY,
          _ref$dispatchPrevente = _ref.dispatchPrevented,
          dispatchPrevented = _ref$dispatchPrevente === undefined ? false : _ref$dispatchPrevente;

      if (!isNaN(x) && x !== null) {
        _prevX = _scrollX;
        _targetX = x | 0;
        _easingX = easingX;
        _durationX = durationX;
        _timestampX = Date.now();
        _dispatchPrevented = dispatchPrevented;
        _tickX++;
      }

      if (!isNaN(y) && y !== null) {
        _prevY = _scrollY;
        _targetY = y | 0;
        _easingY = easingY;
        _durationY = durationY;
        _timestampY = Date.now();
        _dispatchPrevented = dispatchPrevented;
        _tickY++;
      }

      propagateChanges();
    };

    _this.scrollToX = function (x) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollTo((0, _extends3.default)({}, options, { x: x }));
    };

    _this.scrollToY = function (y) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollTo((0, _extends3.default)({}, options, { y: y }));
    };

    _this.scrollBy = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var dx = _ref2.dx,
          dy = _ref2.dy,
          options = (0, _objectWithoutProperties3.default)(_ref2, ['dx', 'dy']);

      _this.scrollTo((0, _extends3.default)({}, options, {
        x: _targetX + dx,
        y: _targetY + dy
      }));
    };

    _this.scrollByX = function (dx) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollBy((0, _extends3.default)({}, options, { dx: dx }));
    };

    _this.scrollByY = function (dy) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollBy((0, _extends3.default)({}, options, { dy: dy }));
    };

    _this.scrollToPage = function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var x = _ref3.x,
          y = _ref3.y,
          options = (0, _objectWithoutProperties3.default)(_ref3, ['x', 'y']);

      x *= _this.getPageWidth();
      y *= _this.getPageHeight();
      _this.scrollTo((0, _extends3.default)({}, options, { x: x, y: y }));
    };

    _this.scrollToPageX = function (x) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollToPage((0, _extends3.default)({}, options, { x: x }));
    };

    _this.scrollToPageY = function (y) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollToPage((0, _extends3.default)({}, options, { y: y }));
    };

    _this.scrollByPage = function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var dx = _ref4.dx,
          dy = _ref4.dy,
          options = (0, _objectWithoutProperties3.default)(_ref4, ['dx', 'dy']);

      dx *= _this.getPageWidth();
      dy *= _this.getPageHeight();
      _this.scrollBy((0, _extends3.default)({}, options, { dx: dx, dy: dy }));
    };

    _this.scrollByPageX = function (dx) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollByPage((0, _extends3.default)({}, options, { dx: dx }));
    };

    _this.scrollByPageY = function (dy) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _this.scrollByPage((0, _extends3.default)({}, options, { dy: dy }));
    };

    _this.getPageWidth = function () {
      return _viewport.clientWidth;
    };

    _this.getPageHeight = function () {
      return _viewport.clientHeight;
    };

    (0, _defineProperties2.default)(_this, {
      targetX: {
        get: function get() {
          return _targetX;
        },
        set: function set(x) {
          return _this.scrollToX(x);
        }
      },
      targetY: {
        get: function get() {
          return _targetY;
        },
        set: function set(y) {
          return _this.scrollToY(y);
        }
      },
      scrollX: {
        get: function get() {
          return _scrollX;
        },
        set: function set(x) {
          return _this.scrollToX(x);
        }
      },
      scrollY: {
        get: function get() {
          return _scrollY;
        },
        set: function set(y) {
          return _this.scrollToY(y);
        }
      },
      scrollMaxX: {
        get: function get() {
          return _scrollMaxX;
        }
      },
      scrollMaxY: {
        get: function get() {
          return _scrollMaxY;
        }
      }
    });

    var isTargetIgnored = function isTargetIgnored(target) {
      return (/textarea|input/i.test(target.tagName)
      );
    };

    var propagateChanges = function propagateChanges() {
      var _this$props2 = _this.props,
          disableScrollX = _this$props2.disableScrollX,
          disableScrollY = _this$props2.disableScrollY,
          scrollMinX = _this$props2.scrollMinX,
          scrollMinY = _this$props2.scrollMinY,
          nativeScrollBars = _this$props2.nativeScrollBars,
          outsetScrollBarX = _this$props2.outsetScrollBarX,
          outsetScrollBarY = _this$props2.outsetScrollBarY,
          onScroll = _this$props2.onScroll,
          onScrollX = _this$props2.onScrollX,
          onScrollY = _this$props2.onScrollY,
          onScrollStart = _this$props2.onScrollStart,
          onScrollStartX = _this$props2.onScrollStartX,
          onScrollStartY = _this$props2.onScrollStartY,
          onScrollEnd = _this$props2.onScrollEnd,
          onScrollEndX = _this$props2.onScrollEndX,
          onScrollEndY = _this$props2.onScrollEndY;
      var _viewport2 = _viewport,
          clientWidth = _viewport2.clientWidth,
          clientHeight = _viewport2.clientHeight,
          offsetWidth = _viewport2.offsetWidth,
          offsetHeight = _viewport2.offsetHeight,
          scrollWidth = _viewport2.scrollWidth,
          scrollHeight = _viewport2.scrollHeight,
          scrollTop = _viewport2.scrollTop,
          scrollLeft = _viewport2.scrollLeft;


      _scrollMaxX = scrollWidth - clientWidth;
      _scrollMaxY = scrollHeight - clientHeight;

      _requiresScrollBarX = !disableScrollX && _scrollMaxX >= scrollMinX;
      _requiresScrollBarY = !disableScrollY && _scrollMaxY >= scrollMinY;

      _root.classList.toggle('scroll-box--requires-x', _requiresScrollBarX);
      _root.classList.toggle('scroll-box--requires-y', _requiresScrollBarY);

      _viewport.style.height = nativeScrollBars && outsetScrollBarX ? 'calc(100% + ' + (offsetHeight - clientHeight) + 'px)' : '100%';

      _viewport.style.width = nativeScrollBars && outsetScrollBarY ? 'calc(100% + ' + (offsetWidth - clientWidth) + 'px)' : '100%';

      _targetX = Math.max(0, Math.min(_targetX, _scrollMaxX));
      _targetY = Math.max(0, Math.min(_targetY, _scrollMaxY));

      var nextScrollX = _scrollX,
          nextScrollY = _scrollY;

      if (_scrollX === scrollLeft && _scrollY === scrollTop) {
        // Controlled scroll position coincides with viewport position.

        if (nextScrollX !== _targetX) {
          var elapsedX = Date.now() - _timestampX;
          if (elapsedX < _durationX) {
            nextScrollX = _prevX + _easingX(elapsedX / _durationX, elapsedX, 0, 1, _durationX) * (_targetX - _prevX) | 0;
          } else {
            nextScrollX = _targetX;
          }
        }
        if (nextScrollY !== _targetY) {
          var elapsedY = Date.now() - _timestampY;
          if (elapsedY < _durationY) {
            nextScrollY = _prevY + _easingY(elapsedY / _durationY, elapsedY, 0, 1, _durationY) * (_targetY - _prevY) | 0;
          } else {
            nextScrollY = _targetY;
          }
        }
      }

      var clientScrollingX = _scrollX !== scrollLeft,
          clientScrollingY = _scrollY !== scrollTop;

      if (clientScrollingX) {
        _targetX = nextScrollX = scrollLeft;
      }
      if (clientScrollingY) {
        _targetY = nextScrollY = scrollTop;
      }

      var nextScrollingX = nextScrollX !== _targetX,
          nextScrollingY = nextScrollY !== _targetY;

      var dx = _scrollX - nextScrollX,
          dy = _scrollY - nextScrollY;

      var tickX = _tickX,
          tickY = _tickY;

      if (!_dispatchPrevented) {
        // Events can be triggered.
        // Checking ticks after each event callback invocation to ensure that any scroll
        // methods were not called inside those callbacks.

        if ((nextScrollingX || nextScrollingY || clientScrollingX || clientScrollingY) && !_scrollingX && !_scrollingY) {
          onScrollStart(_this, _causeX, _causeY);
        }
        if (tickX === _tickX && nextScrollingX && !_scrollingX) {
          onScrollStartX(_this, _causeX);
        }
        if (tickY === _tickY && nextScrollingY && !_scrollingY) {
          onScrollStartY(_this, _causeY);
        }

        if (tickX === _tickX && tickY === _tickY && (dx || dy)) {
          onScroll(_this, dx, dy, _causeX, _causeY);
        }
        if (tickX === _tickX && dx) {
          onScrollX(_this, dx, _causeX);
        }
        if (tickY === _tickY && dy) {
          onScrollY(_this, dy, _causeY);
        }

        if (tickX === _tickX && tickY === _tickY && !nextScrollingX && !nextScrollingY && (_scrollingX || _scrollingY || clientScrollingX || clientScrollingY)) {
          onScrollEnd(_this, _causeX, _causeY);
        }
        if (tickX === _tickX && !nextScrollingX && _scrollingX) {
          onScrollEndX(_this, _causeX);
        }
        if (tickY === _tickY && !nextScrollingY && _scrollingY) {
          onScrollEndY(_this, _causeY);
        }

        if (tickX === _tickX && (_causeX !== ScrollCause.TOUCH || _causeX !== ScrollCause.HANDLE_DRAG)) {
          _causeX = null;
        }
        if (tickY === _tickY && (_causeY !== ScrollCause.TOUCH || _causeY !== ScrollCause.HANDLE_DRAG)) {
          _causeY = null;
        }
      }

      if (dx && tickX === _tickX) {
        _viewport.scrollLeft = _scrollX = nextScrollX;
      }

      if (dy && tickY === _tickY) {
        _viewport.scrollTop = _scrollY = nextScrollY;
      }

      if (!nativeScrollBars) {
        _trackMaxX = _trackX.clientWidth - _handleX.offsetWidth;
        _handleX.style.width = clientWidth / scrollWidth * 100 + '%';
        _handleX.style.left = _trackMaxX * nextScrollX / _scrollMaxX + 'px';

        _trackMaxY = _trackY.clientHeight - _handleY.offsetHeight;
        _handleY.style.height = clientHeight / scrollHeight * 100 + '%';
        _handleY.style.top = _trackMaxY * nextScrollY / _scrollMaxY + 'px';
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      var target = event.target,
          keyCode = event.keyCode,
          shiftKey = event.shiftKey;
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          captureKeyboard = _this$props3.captureKeyboard,
          keyboardStepX = _this$props3.keyboardStepX,
          keyboardStepY = _this$props3.keyboardStepY,
          keyboardScrollDurationX = _this$props3.keyboardScrollDurationX,
          keyboardScrollDurationY = _this$props3.keyboardScrollDurationY;


      if (disabled || !captureKeyboard || isTargetIgnored(target)) {
        // Do not handle any keyboard events when text-related controls are focused.
        return;
      }

      var optionsX = { duration: keyboardScrollDurationX },
          optionsY = { duration: keyboardScrollDurationY };

      switch (keyCode) {

        case 36:
          // Home
          event.preventDefault();
          _causeY = ScrollCause.KEYBOARD;
          _this.scrollToY(0, optionsY);
          break;

        case 35:
          // End
          event.preventDefault();
          _causeY = ScrollCause.KEYBOARD;
          _this.scrollToY(_scrollMaxY, optionsY);
          break;

        case 33: // Page Up
        case 34:
          // Page Down
          event.preventDefault();
          var dy = _this.getPageHeight(),
              dx = _this.getPageWidth();

          if (keyCode === 33) {
            // Page Up
            dy *= -1;
            dx *= -1;
          }
          if (shiftKey) {
            _causeX = ScrollCause.KEYBOARD;
            _this.scrollByX(dx, optionsX);
          } else {
            _causeY = ScrollCause.KEYBOARD;
            _this.scrollByY(dy, optionsY);
          }
          break;

        case 38:
          // Up
          event.preventDefault();
          _causeY = ScrollCause.KEYBOARD;
          _this.scrollByY(-keyboardStepY, optionsY);
          break;

        case 40:
          // Down
          event.preventDefault();
          _causeY = ScrollCause.KEYBOARD;
          _this.scrollByY(keyboardStepY, optionsY);
          break;

        case 37:
          // Left
          event.preventDefault();
          _causeX = ScrollCause.KEYBOARD;
          _this.scrollByX(-keyboardStepX, optionsX);
          break;

        case 39:
          // Right
          event.preventDefault();
          _causeX = ScrollCause.KEYBOARD;
          _this.scrollByX(keyboardStepX, optionsX);
          break;
      }
    };

    var handleFastTrack = function handleFastTrack(event, horizontal) {
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          captureFastTrackX = _this$props4.captureFastTrackX,
          captureFastTrackY = _this$props4.captureFastTrackY,
          fastTrackModeX = _this$props4.fastTrackModeX,
          fastTrackModeY = _this$props4.fastTrackModeY,
          fastTrackScrollDurationX = _this$props4.fastTrackScrollDurationX,
          fastTrackScrollDurationY = _this$props4.fastTrackScrollDurationY;


      if (disabled || !(captureFastTrackX || captureFastTrackY) || event.button) {
        // Component is disabled or secondary mouse button is being pressed.
        return;
      }

      var _viewport3 = _viewport,
          clientWidth = _viewport3.clientWidth,
          clientHeight = _viewport3.clientHeight,
          scrollWidth = _viewport3.scrollWidth,
          scrollHeight = _viewport3.scrollHeight;


      if (horizontal) {
        if (!captureFastTrackX) {
          return;
        }
        _causeX = ScrollCause.FAST_TRACK;

        var pointerX = event.clientX - _trackX.getBoundingClientRect().left,
            optionsX = { duration: fastTrackScrollDurationX };

        switch (fastTrackModeX) {

          case FastTrackMode.PAGING:
            _this.scrollToX(_targetX + (1 - 2 * (pointerX < _handleX.offsetLeft)) * _this.getPageWidth(), optionsX);
            break;

          case FastTrackMode.GOTO:
            _this.scrollToX(pointerX / _trackX.clientWidth * scrollWidth - clientWidth / 2, optionsX);
            break;
        }
      } else {
        if (!captureFastTrackY) {
          return;
        }
        _causeY = ScrollCause.FAST_TRACK;

        var pointerY = event.clientY - _trackY.getBoundingClientRect().top,
            optionsY = { duration: fastTrackScrollDurationY };

        switch (fastTrackModeY) {

          case FastTrackMode.PAGING:
            _this.scrollToY(_targetY + (1 - 2 * (pointerY < _handleY.offsetTop)) * _this.getPageHeight(), optionsY);
            break;

          case FastTrackMode.GOTO:
            _this.scrollToY(pointerY / _trackY.clientHeight * scrollHeight - clientHeight / 2, optionsY);
            break;
        }
      }
    };

    var handleFastTrackX = function handleFastTrackX(event) {
      return handleFastTrack(event, true);
    };

    var handleFastTrackY = function handleFastTrackY(event) {
      return handleFastTrack(event, false);
    };

    var handleDragStart = function handleDragStart(event, horizontal) {
      var _this$props5 = _this.props,
          disabled = _this$props5.disabled,
          captureHandleDragX = _this$props5.captureHandleDragX,
          captureHandleDragY = _this$props5.captureHandleDragY,
          interruptibleHandleDrag = _this$props5.interruptibleHandleDrag;

      // Handle can be dragged with left mouse button only.

      if (disabled || !(captureHandleDragX || captureHandleDragY) || event.button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      var track = void 0;
      if (horizontal) {
        _causeX = ScrollCause.HANDLE_DRAG;
        track = _trackX;
      } else {
        _causeY = ScrollCause.HANDLE_DRAG;
        track = _trackY;
      }

      var offsetX = event.clientX - _handleX.offsetLeft,
          offsetY = event.clientY - _handleY.offsetTop;

      var handleDrag = function handleDrag(event) {
        var cause = horizontal ? _causeX : _causeY;
        if (!_root || event.button || interruptibleHandleDrag && cause !== ScrollCause.HANDLE_DRAG) {
          stopDrag();
          return;
        }

        if (horizontal) {
          _causeX = ScrollCause.HANDLE_DRAG;
          _this.scrollToX(_scrollMaxX * (event.clientX - offsetX) / _trackMaxX);
        } else {
          _causeY = ScrollCause.HANDLE_DRAG;
          _this.scrollToY(_scrollMaxY * (event.clientY - offsetY) / _trackMaxY);
        }
      };

      var handleDragEnd = function handleDragEnd() {
        if (horizontal) {
          _causeX = null;
        } else {
          _causeY = null;
        }
        stopDrag();
      };

      var stopDrag = function stopDrag() {
        removeEventListener('mousemove', handleDrag);
        removeEventListener('mouseup', handleDragEnd);

        track.classList.remove('scroll-box__track--dragged');
      };

      addEventListener('mousemove', handleDrag);
      addEventListener('mouseup', handleDragEnd);

      track.classList.add('scroll-box__track--dragged');
    };

    var handleDragStartX = function handleDragStartX(event) {
      return handleDragStart(event, true);
    };

    var handleDragStartY = function handleDragStartY(event) {
      return handleDragStart(event, false);
    };

    var handleWheel = function handleWheel(event) {
      var target = event.target,
          deltaMode = event.deltaMode,
          deltaX = event.deltaX,
          deltaY = event.deltaY,
          shiftKey = event.shiftKey,
          nativeEvent = event.nativeEvent;
      var _this$props6 = _this.props,
          wheelStepX = _this$props6.wheelStepX,
          wheelStepY = _this$props6.wheelStepY,
          disabled = _this$props6.disabled,
          nativeScrollBars = _this$props6.nativeScrollBars,
          captureWheel = _this$props6.captureWheel,
          wheelLineHeight = _this$props6.wheelLineHeight,
          propagateWheelScrollX = _this$props6.propagateWheelScrollX,
          propagateWheelScrollY = _this$props6.propagateWheelScrollY,
          swapWheelAxes = _this$props6.swapWheelAxes,
          wheelScrollDurationX = _this$props6.wheelScrollDurationX,
          wheelScrollDurationY = _this$props6.wheelScrollDurationY;


      if (nativeScrollBars && !captureWheel) {
        event.preventDefault();
      }
      if (disabled || nativeScrollBars || target !== _viewport && isTargetIgnored(target)) {
        return;
      }

      // By default, Google Chrome changes scrolling orientation if shift key is pressed,
      // so propagate this behavior to other browsers as well.
      if (shiftKey && !deltaX) {
        deltaX = deltaY;
        deltaY = 0;
      }

      if (swapWheelAxes) {
        var buffer = deltaX;
        deltaX = deltaY;
        deltaY = buffer;
      }

      var stopPropagationX = !deltaX || _requiresScrollBarX && (deltaX < 0 && _targetX > 0 || deltaX > 0 && _targetX !== _scrollMaxX),
          stopPropagationY = !deltaY || _requiresScrollBarY && (deltaY < 0 && _targetY > 0 || deltaY > 0 && _targetY !== _scrollMaxY);

      var propagateX = deltaX * !stopPropagationX * propagateWheelScrollX,
          propagateY = deltaY * !stopPropagationY * propagateWheelScrollY;

      if (propagateX || propagateY) {
        if (propagateX === deltaX && propagateY === deltaY) {
          return;
        } else {
          event.stopPropagation();
          event.preventDefault();
          target.dispatchEvent(new WheelEvent(nativeEvent.type, { deltaX: propagateX, deltaY: propagateY }));
        }
      }

      var dx = deltaX * _requiresScrollBarX,
          dy = deltaY * _requiresScrollBarY;

      if (!dx && !dy) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      // Converts received delta values into pixels.
      switch (deltaMode) {

        case 0x01:
          // Delta values are specified in lines.
          dx *= wheelLineHeight;
          dy *= wheelLineHeight;
          break;

        case 0x02:
          // Delta values are specified in pages.
          dx *= _this.getPageWidth();
          dy *= _this.getPageHeight();
          break;

        default:
          // Delta values are specified in pixels.
          break;
      }

      dx *= wheelStepX / 100;
      dy *= wheelStepY / 100;

      var nextTargetX = _targetX + dx,
          nextTargetY = _targetY + dy;

      // Prevent jumping to target position when animated scrolling is in progress,
      // but preserve scroll speed when mouse wheel events arrive frequently.
      if (Date.now() - _timestampX > wheelScrollDurationX) {
        nextTargetX = _scrollX + dx;
      }
      if (Date.now() - _timestampX > wheelScrollDurationY) {
        nextTargetY = _scrollY + dy;
      }

      if (dx) {
        _causeX = ScrollCause.MOUSE_WHEEL;
        _this.scrollToX(nextTargetX, { duration: wheelScrollDurationX });
      }
      if (dy) {
        _causeY = ScrollCause.MOUSE_WHEEL;
        _this.scrollToY(nextTargetY, { duration: wheelScrollDurationY });
      }
    };

    var toggleTrackHover = function toggleTrackHover(track, status) {
      return track.classList.toggle('scroll-box__track--hover', status);
    };

    var isTrackHovered = function isTrackHovered(event, track, proximity) {
      var clientX = event.clientX,
          clientY = event.clientY,
          _track$getBoundingCli = track.getBoundingClientRect(),
          width = _track$getBoundingCli.width,
          left = _track$getBoundingCli.left,
          top = _track$getBoundingCli.top,
          height = _track$getBoundingCli.height;

      return proximity > clientY - height - top && proximity > clientX - width - left && proximity > left - clientX && proximity > top - clientY;
    };

    var handleTrackHover = function handleTrackHover(event) {
      var _this$props7 = _this.props,
          disabled = _this$props7.disabled,
          nativeScrollBars = _this$props7.nativeScrollBars,
          captureHandleDragX = _this$props7.captureHandleDragX,
          captureHandleDragY = _this$props7.captureHandleDragY,
          captureFastTrackX = _this$props7.captureFastTrackX,
          captureFastTrackY = _this$props7.captureFastTrackY,
          trackHoverProximityX = _this$props7.trackHoverProximityX,
          trackHoverProximityY = _this$props7.trackHoverProximityY;


      if ('orientation' in window || nativeScrollBars || disabled) {
        return;
      }

      if (_requiresScrollBarX && (captureHandleDragX || captureFastTrackX)) {
        var statusX = (!event.buttons || _causeX === ScrollCause.HANDLE_DRAG) && isTrackHovered(event, _trackX, trackHoverProximityX);
        toggleTrackHover(_trackX, statusX);
      }
      if (_requiresScrollBarY && (captureHandleDragY || captureFastTrackY)) {
        var statusY = (!event.buttons || _causeY === ScrollCause.HANDLE_DRAG) && isTrackHovered(event, _trackY, trackHoverProximityY);
        toggleTrackHover(_trackY, statusY);
      }
    };

    var isIgnoredChangeX = function isIgnoredChangeX(dx) {
      return dx < 0 && !_targetX || dx > 0 && _targetX === _scrollMaxX;
    };

    var isIgnoredChangeY = function isIgnoredChangeY(dy) {
      return dy < 0 && !_targetY || dy > 0 && _targetY === _scrollMaxY;
    };

    var preventDefault = function preventDefault(event) {
      if (event.cancelable) {
        event.preventDefault();
      }
    };

    var handleTouchStart = function handleTouchStart(event) {
      var target = event.target,
          touches = event.touches;
      var _this$props8 = _this.props,
          disabled = _this$props8.disabled,
          nativeScrollBars = _this$props8.nativeScrollBars,
          captureTouch = _this$props8.captureTouch,
          propagateTouchScrollX = _this$props8.propagateTouchScrollX,
          propagateTouchScrollY = _this$props8.propagateTouchScrollY,
          touchSingleAxis = _this$props8.touchSingleAxis,
          touchStartDistance = _this$props8.touchStartDistance,
          continuousTouchScrollX = _this$props8.continuousTouchScrollX,
          continuousTouchScrollY = _this$props8.continuousTouchScrollY,
          inertiaEasingX = _this$props8.inertiaEasingX,
          inertiaEasingY = _this$props8.inertiaEasingY,
          inertiaDistanceX = _this$props8.inertiaDistanceX,
          inertiaDistanceY = _this$props8.inertiaDistanceY,
          inertiaDurationX = _this$props8.inertiaDurationX,
          inertiaDurationY = _this$props8.inertiaDurationY;


      if (nativeScrollBars && !captureTouch) {
        preventDefault(event);
      }
      if (disabled || nativeScrollBars || touches.length > 1 || target !== _viewport && isTargetIgnored(target)) {
        return;
      }

      var _touches$ = touches[0],
          initialClientX = _touches$.clientX,
          initialClientY = _touches$.clientY;

      var initialScrollX = _scrollX,
          initialScrollY = _scrollY;

      var prevClientX = void 0,
          prevClientY = void 0,
          lastClientX = void 0,
          lastClientY = void 0,
          prevTimestamp = void 0,
          lastTimestamp = void 0,
          horizontal = void 0,
          stopPropagationX = void 0,
          stopPropagationY = void 0;

      var handleTouchMove = function handleTouchMove(event) {
        var _event$touches$ = event.touches[0],
            clientX = _event$touches$.clientX,
            clientY = _event$touches$.clientY;

        var dx = initialClientX - clientX,
            dy = initialClientY - clientY,
            pending = isNaN(lastClientX);

        if (pending && Math.sqrt(dx * dx + dy * dy) < touchStartDistance) {
          preventDefault(event);
          return;
        }
        if (pending && touchSingleAxis) {
          horizontal = Math.abs(dx) > Math.abs(dy);
        }
        if (pending || continuousTouchScrollX) {
          stopPropagationX = _requiresScrollBarX && !isIgnoredChangeX(dx);
        }
        if (pending || continuousTouchScrollY) {
          stopPropagationY = _requiresScrollBarY && !isIgnoredChangeY(dy);
        }

        prevClientX = lastClientX;
        prevClientY = lastClientY;
        lastClientX = clientX;
        lastClientY = clientY;
        prevTimestamp = lastTimestamp;
        lastTimestamp = Date.now();

        var targetX = initialScrollX + dx,
            targetY = initialScrollY + dy;

        if (touchSingleAxis) {
          if (horizontal) {
            if (stopPropagationX || !propagateTouchScrollX) {
              preventDefault(event);
              _this.scrollToX(targetX);
            }
          } else {
            if (stopPropagationY || !propagateTouchScrollY) {
              preventDefault(event);
              _this.scrollToY(targetY);
            }
          }
        } else {
          if (stopPropagationX || stopPropagationY || !propagateTouchScrollX && !propagateTouchScrollY) {
            preventDefault(event);
            _this.scrollTo({ x: targetX, y: targetY });
          }
        }
      };

      var handleTouchEnd = function handleTouchEnd() {
        if (!isNaN(prevClientX)) {
          var dt = lastTimestamp - prevTimestamp,
              dx = prevClientX - lastClientX,
              dy = prevClientY - lastClientY,
              distanceX = inertiaDistanceX(dx, dt),
              distanceY = inertiaDistanceY(dy, dt),
              durationX = Math.abs(inertiaDurationX(dx, dt)),
              durationY = Math.abs(inertiaDurationY(dy, dt));

          var targetX = _targetX + distanceX,
              targetY = _targetY + distanceY;

          if (touchSingleAxis) {
            if (horizontal) {
              _this.scrollToX(targetX, { easingX: inertiaEasingX, durationX: durationX });
            } else {
              _this.scrollToY(targetY, { easingY: inertiaEasingY, durationY: 100 });
            }
          } else {
            _this.scrollTo({
              x: targetX,
              y: targetY,
              easingX: inertiaEasingX,
              easingY: inertiaEasingY,
              durationX: durationX,
              durationY: durationY
            });
          }
        }
        removeEventListener('touchmove', handleTouchMove);
        removeEventListener('touchend', handleTouchEnd);
        removeEventListener('touchcancel', handleTouchEnd);
      };

      addEventListener('touchmove', handleTouchMove, { passive: false });
      addEventListener('touchend', handleTouchEnd);
      addEventListener('touchcancel', handleTouchEnd);
    };
    return _this;
  }

  return AbstractScrollBox;
}(_react2.default.Component);

AbstractScrollBox.propTypes = {
  // Viewport element.
  children: _propTypes.element.isRequired,

  // Use native client scroll bars.
  nativeScrollBars: _propTypes.bool,

  className: _propTypes.string,
  style: _propTypes.object,

  disabled: _propTypes.bool,

  // Events
  onScroll: _propTypes.func,
  onScrollX: _propTypes.func,
  onScrollY: _propTypes.func,

  onScrollStart: _propTypes.func,
  onScrollStartX: _propTypes.func,
  onScrollStartY: _propTypes.func,

  onScrollEnd: _propTypes.func,
  onScrollEndX: _propTypes.func,
  onScrollEndY: _propTypes.func,

  // Disable scrolling in corresponding direction.
  disableScrollX: _propTypes.bool,
  disableScrollY: _propTypes.bool,

  // Toggle scroll bar visibility for corresponding direction.
  hideScrollBarX: _propTypes.bool,
  hideScrollBarY: _propTypes.bool,

  // Toggle show scroll bars outside of scroll box rectangle.
  // This has no effect when native scroll bars are enabled on mobile device.
  outsetScrollBarX: _propTypes.bool,
  outsetScrollBarY: _propTypes.bool,

  // Minimum number of pixels when scroll bars are required.
  scrollMinX: _propTypes.number,
  scrollMinY: _propTypes.number,

  // Distance from cursor to edge of the scroll track when scroll bar is considered to be hovered.
  trackHoverProximityX: _propTypes.number,
  trackHoverProximityY: _propTypes.number,

  // Default easing functions applied when scroll with non-zero duration is requested.
  easingX: _propTypes.func,
  easingY: _propTypes.func,

  // Handle drag
  captureHandleDragX: _propTypes.bool,
  captureHandleDragY: _propTypes.bool,
  // Interrupt handle drag when programmatic scrolling requested.
  interruptibleHandleDrag: _propTypes.bool,

  // Fast tracking occurs when user clicks on scroll track.
  captureFastTrackX: _propTypes.bool,
  captureFastTrackY: _propTypes.bool,

  fastTrackModeX: (0, _propTypes.oneOf)((0, _values2.default)(FastTrackMode)),
  fastTrackModeY: (0, _propTypes.oneOf)((0, _values2.default)(FastTrackMode)),

  fastTrackScrollDurationX: _propTypes.number,
  fastTrackScrollDurationY: _propTypes.number,

  // Keyboard
  captureKeyboard: _propTypes.bool,
  keyboardStepX: _propTypes.number,
  keyboardStepY: _propTypes.number,
  keyboardScrollDurationX: _propTypes.number,
  keyboardScrollDurationY: _propTypes.number,

  // Wheel
  captureWheel: _propTypes.bool,
  wheelLineHeight: _propTypes.number,
  wheelStepX: _propTypes.number,
  wheelStepY: _propTypes.number,
  propagateWheelScrollX: _propTypes.bool,
  propagateWheelScrollY: _propTypes.bool,
  swapWheelAxes: _propTypes.bool,
  wheelScrollDurationX: _propTypes.number,
  wheelScrollDurationY: _propTypes.number,

  // Touch
  captureTouch: _propTypes.bool,
  propagateTouchScrollX: _propTypes.bool,
  propagateTouchScrollY: _propTypes.bool,
  touchSingleAxis: _propTypes.bool,
  touchStartDistance: _propTypes.number,
  continuousTouchScrollX: _propTypes.bool,
  continuousTouchScrollY: _propTypes.bool,

  inertiaEasingX: _propTypes.func,
  inertiaEasingY: _propTypes.func,
  inertiaDistanceX: _propTypes.func,
  inertiaDistanceY: _propTypes.func,
  inertiaDurationX: _propTypes.func,
  inertiaDurationY: _propTypes.func,

  // Layout
  trackChildrenX: _propTypes.node,
  trackChildrenY: _propTypes.node,
  handleChildrenX: _propTypes.node,
  handleChildrenY: _propTypes.node
};
AbstractScrollBox.defaultProps = {
  nativeScrollBars: false,

  className: 'scroll-box--wrapped',
  style: null,

  disabled: false,

  onScroll: function onScroll(target, dx, dy, causeX, causeY) {},
  onScrollX: function onScrollX(target, dx, causeX) {},
  onScrollY: function onScrollY(target, dy, causeY) {},
  onScrollStart: function onScrollStart(target, causeX, causeY) {},
  onScrollStartX: function onScrollStartX(target, causeX) {},
  onScrollStartY: function onScrollStartY(target, causeY) {},
  onScrollEnd: function onScrollEnd(target, causeX, causeY) {},
  onScrollEndX: function onScrollEndX(target, causeX) {},
  onScrollEndY: function onScrollEndY(target, causeY) {},


  disableScrollX: false,
  disableScrollY: false,

  hideScrollBarX: false,
  hideScrollBarY: false,

  outsetScrollBarX: false,
  outsetScrollBarY: false,

  scrollMinX: 2,
  scrollMinY: 2,

  trackHoverProximityX: 50,
  trackHoverProximityY: 50,

  easingX: ScrollEasing.easeQuadOut,
  easingY: ScrollEasing.easeQuadOut,

  // Handle drag
  captureHandleDragX: true,
  captureHandleDragY: true,
  interruptibleHandleDrag: true,

  // Fast track
  captureFastTrackX: true,
  captureFastTrackY: true,

  fastTrackModeX: FastTrackMode.GOTO,
  fastTrackModeY: FastTrackMode.GOTO,

  fastTrackScrollDurationX: 500,
  fastTrackScrollDurationY: 500,

  // Keyboard
  captureKeyboard: true,
  keyboardStepX: 30,
  keyboardStepY: 30,
  keyboardScrollDurationX: 200,
  keyboardScrollDurationY: 200,

  // Wheel
  captureWheel: true,
  // Used when scroll by line-height is requested.
  wheelLineHeight: 24,
  wheelStepX: 100,
  wheelStepY: 100,
  propagateWheelScrollX: false,
  propagateWheelScrollY: true,
  swapWheelAxes: false,
  wheelScrollDurationX: 100,
  wheelScrollDurationY: 100,

  // Touch
  captureTouch: true,
  propagateTouchScrollX: true,
  propagateTouchScrollY: true,
  touchSingleAxis: true,
  touchStartDistance: 10,
  continuousTouchScrollX: false,
  continuousTouchScrollY: false,

  inertiaEasingX: ScrollEasing.easeQuadOut,
  inertiaEasingY: ScrollEasing.easeQuadOut,
  inertiaDistanceX: function inertiaDistanceX(dx, dt) {
    return dx / dt * 100;
  },
  inertiaDistanceY: function inertiaDistanceY(dy, dt) {
    return dy / dt * 100;
  },
  inertiaDurationX: function inertiaDurationX(dx, dt) {
    return dx / dt * 100;
  },
  inertiaDurationY: function inertiaDurationY(dy, dt) {
    return dy / dt * 100;
  },

  // Layout
  trackChildrenX: null,
  trackChildrenY: null,
  handleChildrenX: null,
  handleChildrenY: null
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(67), __esModule: true };

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(56);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(53);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(35);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(35);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(59);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(58);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(72);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(2) && !__webpack_require__(7)(function(){
  return Object.defineProperty(__webpack_require__(38)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(36);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(19)
  , $export        = __webpack_require__(1)
  , redefine       = __webpack_require__(47)
  , hide           = __webpack_require__(8)
  , has            = __webpack_require__(5)
  , Iterators      = __webpack_require__(18)
  , $iterCreate    = __webpack_require__(78)
  , setToStringTag = __webpack_require__(22)
  , getPrototypeOf = __webpack_require__(45)
  , ITERATOR       = __webpack_require__(10)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(6)
  , anObject = __webpack_require__(11)
  , getKeys  = __webpack_require__(9);

module.exports = __webpack_require__(2) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(13)
  , createDesc     = __webpack_require__(14)
  , toIObject      = __webpack_require__(4)
  , toPrimitive    = __webpack_require__(27)
  , has            = __webpack_require__(5)
  , IE8_DOM_DEFINE = __webpack_require__(39)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(2) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(46)
  , hiddenKeys = __webpack_require__(17).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(5)
  , toObject    = __webpack_require__(26)
  , IE_PROTO    = __webpack_require__(23)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(5)
  , toIObject    = __webpack_require__(4)
  , arrayIndexOf = __webpack_require__(74)(false)
  , IE_PROTO     = __webpack_require__(23)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = react;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollBox = __webpack_require__(51);

Object.defineProperty(exports, 'ScrollBox', {
  enumerable: true,
  get: function get() {
    return _ScrollBox.ScrollBox;
  }
});

var _AbstractScrollBox = __webpack_require__(30);

Object.defineProperty(exports, 'AbstractScrollBox', {
  enumerable: true,
  get: function get() {
    return _AbstractScrollBox.AbstractScrollBox;
  }
});
Object.defineProperty(exports, 'FastTrackMode', {
  enumerable: true,
  get: function get() {
    return _AbstractScrollBox.FastTrackMode;
  }
});
Object.defineProperty(exports, 'ScrollCause', {
  enumerable: true,
  get: function get() {
    return _AbstractScrollBox.ScrollCause;
  }
});

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollBox = undefined;

var _getPrototypeOf = __webpack_require__(31);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(32);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(60);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(34);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(33);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(48);

var _react2 = _interopRequireDefault(_react);

var _AbstractScrollBox = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollBox = exports.ScrollBox = function (_React$Component) {
  (0, _inherits3.default)(ScrollBox, _React$Component);

  function ScrollBox() {
    (0, _classCallCheck3.default)(this, ScrollBox);
    return (0, _possibleConstructorReturn3.default)(this, (ScrollBox.__proto__ || (0, _getPrototypeOf2.default)(ScrollBox)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScrollBox, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _AbstractScrollBox.AbstractScrollBox,
        this.props,
        _react2.default.createElement(
          'div',
          { className: 'scroll-box__viewport' },
          this.props.children
        )
      );
    }
  }]);
  return ScrollBox;
}(_react2.default.Component);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(64), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(65), __esModule: true };

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(66), __esModule: true };

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(68), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(69), __esModule: true };

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(71), __esModule: true };

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(55);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(52);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91);
module.exports = __webpack_require__(0).Object.assign;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(92);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperties(T, D){
  return $Object.defineProperties(T, D);
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(94);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95);
module.exports = __webpack_require__(0).Object.getPrototypeOf;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
module.exports = __webpack_require__(0).Object.setPrototypeOf;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(0).Object.values;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
__webpack_require__(97);
__webpack_require__(101);
__webpack_require__(102);
module.exports = __webpack_require__(0).Symbol;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(98);
__webpack_require__(103);
module.exports = __webpack_require__(29).f('iterator');

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(4)
  , toLength  = __webpack_require__(89)
  , toIndex   = __webpack_require__(88);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(9)
  , gOPS    = __webpack_require__(21)
  , pIE     = __webpack_require__(13);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3).document && document.documentElement;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(36);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(20)
  , descriptor     = __webpack_require__(14)
  , setToStringTag = __webpack_require__(22)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(8)(IteratorPrototype, __webpack_require__(10)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(9)
  , toIObject = __webpack_require__(4);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(15)('meta')
  , isObject = __webpack_require__(12)
  , has      = __webpack_require__(5)
  , setDesc  = __webpack_require__(6).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(7)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(9)
  , gOPS     = __webpack_require__(21)
  , pIE      = __webpack_require__(13)
  , toObject = __webpack_require__(26)
  , IObject  = __webpack_require__(40)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(4)
  , gOPN      = __webpack_require__(44).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1)
  , core    = __webpack_require__(0)
  , fails   = __webpack_require__(7);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(9)
  , toIObject = __webpack_require__(4)
  , isEnum    = __webpack_require__(13).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12)
  , anObject = __webpack_require__(11);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(37)(Function.call, __webpack_require__(43).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(25)
  , defined   = __webpack_require__(16);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(25)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(25)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(73)
  , step             = __webpack_require__(79)
  , Iterators        = __webpack_require__(18)
  , toIObject        = __webpack_require__(4);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(41)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(82)});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(20)});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(2), 'Object', {defineProperties: __webpack_require__(42)});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(2), 'Object', {defineProperty: __webpack_require__(6).f});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(26)
  , $getPrototypeOf = __webpack_require__(45);

__webpack_require__(84)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(86).set});

/***/ }),
/* 97 */
/***/ (function(module, exports) {



/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(87)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(41)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(3)
  , has            = __webpack_require__(5)
  , DESCRIPTORS    = __webpack_require__(2)
  , $export        = __webpack_require__(1)
  , redefine       = __webpack_require__(47)
  , META           = __webpack_require__(81).KEY
  , $fails         = __webpack_require__(7)
  , shared         = __webpack_require__(24)
  , setToStringTag = __webpack_require__(22)
  , uid            = __webpack_require__(15)
  , wks            = __webpack_require__(10)
  , wksExt         = __webpack_require__(29)
  , wksDefine      = __webpack_require__(28)
  , keyOf          = __webpack_require__(80)
  , enumKeys       = __webpack_require__(75)
  , isArray        = __webpack_require__(77)
  , anObject       = __webpack_require__(11)
  , toIObject      = __webpack_require__(4)
  , toPrimitive    = __webpack_require__(27)
  , createDesc     = __webpack_require__(14)
  , _create        = __webpack_require__(20)
  , gOPNExt        = __webpack_require__(83)
  , $GOPD          = __webpack_require__(43)
  , $DP            = __webpack_require__(6)
  , $keys          = __webpack_require__(9)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(44).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(13).f  = $propertyIsEnumerable;
  __webpack_require__(21).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(19)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(8)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1)
  , $values = __webpack_require__(85)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('asyncIterator');

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28)('observable');

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
var global        = __webpack_require__(3)
  , hide          = __webpack_require__(8)
  , Iterators     = __webpack_require__(18)
  , TO_STRING_TAG = __webpack_require__(10)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = prop-types;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = react-dom;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
module.exports = __webpack_require__(49);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js